import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { AssessmentTask } from '@/features/nectar/components/AssessmentTask'
import { Page } from '@/ui-kit'

const AssessmentPage = () => {
  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        <AssessmentTask />
      </Page>
    </MissionsUrlProvider>
  )
}

export default AssessmentPage
